import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash.isempty';
import './style/Dialog.css';
import API from '../api/api';

class DeleteBookingDialog extends React.Component {
    static propTypes = {
        config: PropTypes.object,
        onClose: PropTypes.func,
        boat: PropTypes.string,
        date: PropTypes.object,
        slot: PropTypes.string,
        member: PropTypes.object
    }
    state = {
        code: '',
        contact: null
    }
    render() {
        let submitEnabled = !isEmpty(this.state.code);
        return (
            <div className="dialog-container">
                <div className="dialog">
                    <div className="dialog-title">Dettagli prenotazione</div>
                    <div className="dialog-body">
                        <form action="" onSubmit={this.submit}>
                            <table><tbody>
                                <tr>
                                    <td>Barca:</td>
                                    <td><input type="text" disabled={true} defaultValue={this.props.config.boats[this.props.boat]} /></td>
                                </tr>
                                <tr>
                                    <td>Data:</td>
                                    <td><input type="text" disabled={true} defaultValue={this.props.date.format("DD.MM.YYYY")} /></td>
                                </tr>
                                <tr>
                                    <td>Fascia:</td>
                                    <td><input type="text" disabled={true} defaultValue={this.props.config.daySlots[this.props.slot]} /></td>
                                </tr>
                                <tr>
                                    <td>Nome:</td>
                                    <td><input type="text" disabled={true} defaultValue={this.props.member.firstname + " " + this.props.member.lastname} /></td>
                                </tr>
                                {this.state.contact ? [(
                                    <tr key="phone">
                                        <td>Telefono:</td>
                                        <td><input type="text" defaultValue={this.state.contact.phone} disabled={true} /></td>
                                    </tr>
                                ), null/*(
                                    <tr key="email">
                                        <td>E-Mail:</td>
                                        <td><input type="text" defaultValue={this.state.contact.email} disabled={true} /></td>
                                    </tr>
                                )*/] : null}
                                <tr>
                                    <td>ID:</td>
                                    <td><input type="text" placeholder={"Indicato sulla tessera membro"} value={this.state.code} onChange={ev => this.setState({code: ev.target.value.toLowerCase()})} /></td>
                                </tr>
                                {!this.state.contact ? (
                                    <tr>
                                        <td colSpan="2">
                                            <div className="dialog-buttonbar">
                                                <button type="button" onClick={ev => this.queryContact()} className="button-important" disabled={!submitEnabled}>Mostra Telefono</button>
                                            </div>
                                        </td>
                                    </tr>
                                ) : null}
                                <tr>
                                    <td colSpan="2">
                                        <div className="dialog-buttonbar">
                                            <button type="submit" className="button-important" disabled={!submitEnabled}>Elimina</button>
                                            <button type="button" onClick={ev => this.props.onClose()}>Annulla</button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody></table>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
    submit = (ev) => {
        ev.preventDefault();
        API.deleteBooking(this.props.boat, this.props.date, this.props.slot, this.state.code, (success, data) => {
            if(success) {
                this.props.onClose(true);
            } else {
                alert(data);
            }
        });
    }
    queryContact = (ev) => {
        API.queryContact(this.props.member.swsnr, this.state.code, (success, data) => {
            if(success) {
                this.setState({contact: data});
            } else {
                alert(data);
            }
        })
    }
};

export default DeleteBookingDialog;
